<template>
    <div>
        <template v-if="mode === 'default'">
            <a-select v-model="selectId" :mode="mode" :defaultValue="defaultValue" @change="change">
                <a-select-option v-for="item in select" :key="item.id" :value="item.id">{{item.name}}</a-select-option>
            </a-select>
        </template>

        <template v-else-if="mode === 'multiple'">
            <a-select v-model="selectId" :mode="mode" :defaultValue="defaultValue" :labelInValue="true"  @change="change">
                <a-select-option v-for="item in select" :key="item.id" :value="item.id">{{item.name}}</a-select-option>
            </a-select>
        </template>
    </div>



</template>

<script>
    export default {
        name: "inverterSelectDefault",
        props:{
            mode:{
                type: String,
                default: 'default'
            }
        },
        data(){
            return {
                groupId: this.$Utils.getUserStorage().groupId,
                select: [],
                defaultValue: 0,
                selectId: 0,
                stationId: 0,
            }
        },
        methods:{

            init(id = 0){
                this.stationId = id;
                this.loadInverter();
            },

            async loadInverter(){
                let inverter = await this.$http.get(this.$baseURL.inverterList({groupId: this.groupId, powerStationId: this.stationId}));
                //console.log(inverter)
                this.select = [];
                let array = [];
                let allArray = [];
                if(this.mode === 'default'){
                    if(inverter.length > 0) {
                        inverter.forEach((item, index) => {
                            if (index === 0) {
                                this.selectId = item.id.toString();
                            }
                            array.push({
                                id: item.id.toString(),
                                name: item.name
                            });
                        });
                    }else  {
                        this.selectId = 'null';
                        array.push({
                            id: 'null',
                            name: '不限'
                        });
                    }
                } else if(this.mode === 'multiple'){
                    if(inverter.length > 0){
                        inverter.forEach((item, index) =>{
                            if(index === 0){
                                this.selectId = [{
                                    key: item.id.toString(),
                                    value: item.name
                                }];
                            }
                            array.push({
                                id: item.id.toString(),
                                name: item.name
                            });
                            allArray.push(item.id);
                        });
                    } else {
                        this.selectId = [{
                            key: 'null',
                            value: '不限'
                        }];
                        array.push({
                            id: 'null',
                            name: '不限'
                        });
                    }

                    let allValue = allArray.toString();
                }
                if(array.length > 0){
                    this.select = array;
                }

                console.log('selectList = ', this.select, " default = ", this.selectId)
                this.selectInverter()
            },
            change(value){
                if(this.mode === 'multiple'){
                    if(this.selectId.length >0){
                        this.selectId = value;
                    }

                }
                this.selectInverter();
            },
            selectInverter(){

                if(this.mode === 'default'){
                    this.$emit('changeInverter', this.selectId);
                } else if(this.mode === 'multiple'){
                    let str = [];
                    if(this.selectId.length > 0){
                        this.selectId.forEach(item =>{
                            str.push(item.key)
                        });
                        this.$emit('changeInverter', str.join(','));
                    } else {
                        this.$emit('changeInverter', 'null');
                    }


                }


            }

        }
    }
</script>

<style scoped>

</style>
